<template>
  <div>
    <topsearch title="Import Raporu" />
    <div class="flex">
      <div class="w-72 border-r h-full">
        <SidebarVue />
      </div>
      <div class="w-full">
        <div class="overflow-scroll min-h-screen md:p-4">
          <!-- Tarih Filtresi -->
          <div class="flex items-center gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
            <div class="flex items-center gap-2">
              <label class="text-sm font-medium text-gray-700">Başlangıç:</label>
              <input
                type="date"
                v-model="startDate"
                class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div class="flex items-center gap-2">
              <label class="text-sm font-medium text-gray-700">Bitiş:</label>
              <input
                type="date"
                v-model="endDate"
                class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button
              @click="getData"
              class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Filtrele
            </button>
            <button
              @click="resetFilter"
              class="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors"
            >
              Sıfırla
            </button>
          </div>

          <div class="border-b border-gray-200 mb-4">
            <nav class="flex space-x-4" aria-label="Tabs" role="tablist">
              <button
                v-for="tab in tabs"
                :key="tab.key"
                type="button"
                role="tab"
                :aria-selected="activeTab === tab.key"
                :class="{ 'border-tile-500 text-tile-500': activeTab === tab.key }"
                class="py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500"
                @click="changeTab(tab.key)"
              >
                {{ tab.label }}
              </button>
            </nav>
          </div>

          <!-- Analiz sekmesi açılmadan sorgu atılmaz; sekmeler arası geçişte
               tekrar hesaplanmaz. -->
          <keep-alive>
            <import-trends
              v-if="activeTab === 'trends'"
              :start-date="appliedStart"
              :end-date="appliedEnd"
              :reload-key="trendReloadKey"
            />
          </keep-alive>

          <table
            v-if="activeTab === 'uploads'"
            class="uk-table uk-table-hover uk-table-middle uk-table-divider"
          >
            <tr>
              <td>Excel ID</td>
              <td>Double Sayısı</td>
              <td>Eklenen Kayıt Sayısı</td>
              <td>İşlem Zamanı</td>
            </tr>
            <tr :key="item.excel_id" v-for="item in data">
              <td>{{ item.excel_id }}</td>
              <td>
                <a
                  v-if="item.double > 0 && item.double_ids"
                  class="cursor-pointer"
                  title="Double kayıtları agent / retention'a dağıt"
                  @click="distributeReport = item"
                >{{ item.double }}</a>
                <template v-else>{{ item.double }}</template>
                <span
                  v-if="item.last_distribution"
                  class="ml-2 px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-800 whitespace-nowrap"
                  :title="'Son dağıtım: ' + item.last_distribution.created_at + ' · ' + (item.last_distribution.user_name || '-') + ' · ' + item.last_distribution.lead_count + ' kayıt'"
                >
                  Dağıtıldı<template v-if="item.last_distribution.distribution_count > 1">
                    ({{ item.last_distribution.distribution_count }}x)</template>
                </span>
              </td>
              <td>
                <a :href="'/list/leads/?excel_id=' + item.excel_id">{{
                  item.total
                }}</a>
              </td>
              <td>{{ item.created_at }}</td>
              <td>
                <span @click="excelDownload(item.double_ids)" class="global-button cursor-pointer">Double Listesi İndir</span>
              </td>
            </tr>
          </table>
        </div>
        <double-distribute-modal
          v-if="distributeReport"
          :report="distributeReport"
          @close="distributeReport = null"
          @distributed="getData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SidebarVue from "../components/Ui/Admin/Sidebar.vue";
import DoubleDistributeModal from "../components/Datatable/DoubleDistributeModal.vue";
import ImportTrends from "../components/Ui/ImportTrends.vue";
import EventBus from "../components/Ui/EventBus";
import http from "../services/http";
export default {
  components: { SidebarVue, DoubleDistributeModal, ImportTrends },
  name: "reportUtm",
  data() {
    // Son 1 ay varsayılan tarih aralığı
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    return {
      data: [],
      distributeReport: null,
      statuses: [],
      utmKey: "utm_source",
      startDate: oneMonthAgo.toISOString().split('T')[0],
      endDate: today.toISOString().split('T')[0],
      // Trend bileşeni yazarken değil, "Filtrele"de güncellensin.
      appliedStart: oneMonthAgo.toISOString().split('T')[0],
      appliedEnd: today.toISOString().split('T')[0],
      trendReloadKey: 0,
      tabs: [
        { key: "uploads", label: "Yüklemeler" },
        { key: "trends", label: "Trend ve Double Analizi" },
      ],
      // Adreste tutulur (?tab=trends): yenileme / paylaşılan bağlantı aynı sekmeyi açar.
      activeTab: this.$route.query.tab === "trends" ? "trends" : "uploads",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    excelDownload(ids) {
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "info",
        title: "Lütfen bekleyin",
        duration: 2000,
        body: "Dosya hazırlanıyor lütfen bekleyin",
      });

      http
        .exportDoubleExcel("leads", {
          double_ids: ids,
        })
        .then((response) => {
          if (response.data.success && response.data.excelFiles.length > 0) {
            // Dosya isimlerini birleştirerek tek bir string haline getir
            let fileList = response.data.excelFiles.join("\n");
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "info",
              title: "Dosyalar hazır",
              body: fileList,
            });
          } else {
            alert("Dosya oluşturulamadı veya dosya yok.");
          }
        })
        .catch((error) => {
          console.error("İndirme hatası: ", error);
        });
    },
    getData() {
      http.getImportReports(this.startDate, this.endDate).then((response) => {
        this.data = response.data;
      });
      if (this.appliedStart !== this.startDate || this.appliedEnd !== this.endDate) {
        this.appliedStart = this.startDate;
        this.appliedEnd = this.endDate;
        this.trendReloadKey++;
      }
    },
    changeTab(key) {
      if (this.activeTab === key) return;
      this.activeTab = key;
      const query = Object.assign({}, this.$route.query, {
        tab: key === "uploads" ? undefined : key,
      });
      this.$router.replace({ query }).catch(() => {});
    },
    resetFilter() {
      // Son 1 ay'a sıfırla
      const today = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      this.startDate = oneMonthAgo.toISOString().split('T')[0];
      this.endDate = today.toISOString().split('T')[0];
      this.getData();
    },
  },
};
</script>

<style></style>
